import Model from "./abstract/Model";
import dayjs from "dayjs"

export default class VehicleLocking extends Model {

  country_ids;

  constructor(props) {
    super();

    this.initializeAttributes(props, {
      locked_until: (value) => dayjs(value, { utc: true }).toDate(),
      extension_allowed_at: (value) => dayjs(value, { utc: true }).toDate()
    });
  }

  get locked_until_as_time() {
    return this.locked_until.getTime();
  }

  get time_until_unlocked() {
    return this.locked_until_as_time - (new Date).getTime();
  }

  get extension_allowed_at_as_time() {
    return this.extension_allowed_at.getTime();
  }
}
